import { render, staticRenderFns } from "./IgG.vue?vue&type=template&id=c709b178&scoped=true"
import script from "./IgG.vue?vue&type=script&lang=js"
export * from "./IgG.vue?vue&type=script&lang=js"
import style0 from "./IgG.vue?vue&type=style&index=0&id=c709b178&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c709b178",
  null
  
)

export default component.exports